import React, { useState, useRef, useCallback } from 'react';
import EmojiPicker from 'emoji-picker-react';
import { Button } from '../ui/button';
import { Smile, X } from 'lucide-react';
import { cn } from '../../lib/utils';

export const EmojiPickerButton = ({ onEmojiSelect, className }) => {
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);

  const handleEmojiClick = (emojiData) => {
    onEmojiSelect(emojiData.emoji);
    setShowPicker(false);
  };

  return (
    <div className={cn("relative", className)}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="rounded-full text-muted-foreground hover:text-primary"
        onClick={() => setShowPicker(!showPicker)}
        ref={buttonRef}
        data-testid="emoji-picker-btn"
      >
        <Smile className="w-5 h-5" />
      </Button>

      {showPicker && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowPicker(false)} 
          />
          
          {/* Picker */}
          <div className="absolute bottom-full right-0 mb-2 z-50 animate-scale-in">
            <div className="relative bg-background rounded-2xl shadow-xl border border-border overflow-hidden">
              <Button
                variant="ghost"
                size="icon"
                className="absolute top-2 right-2 z-10 rounded-full w-8 h-8 bg-background/80"
                onClick={() => setShowPicker(false)}
              >
                <X className="w-4 h-4" />
              </Button>
              <EmojiPicker
                onEmojiClick={handleEmojiClick}
                width={320}
                height={400}
                searchPlaceholder="Search emoji..."
                skinTonesDisabled
                theme="auto"
                lazyLoadEmojis
                previewConfig={{ showPreview: false }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

// Quick emoji reactions
export const QuickEmojis = ({ onSelect, className }) => {
  const quickEmojis = ['❤️', '😂', '😮', '😢', '😡', '👍', '🔥', '💯'];
  
  return (
    <div className={cn("flex gap-1", className)}>
      {quickEmojis.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => onSelect(emoji)}
          className="w-8 h-8 flex items-center justify-center text-lg hover:bg-secondary rounded-full transition-colors"
          data-testid={`quick-emoji-${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

export default EmojiPickerButton;
